import { createFileRoute } from "@tanstack/react-router";
import { NoticeScreen } from "../screens/staff/NoticeScreen.tsx";

/** `/sysadmin/notices`: tell every customer company's administrators about a change of sub-processor. */
export const Route = createFileRoute("/_staff/sysadmin/notices")({
  component: NoticeScreen,
});
